"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
https://github.com/leozdgao/react-async-script-loader
A decorator for script lazy loading on react component
API

scriptLoader(...scriptSrc)([WrappedComponent])
scriptSrc can be a string of source or an array of source. scriptSrc will be loaded sequentially, but array of source will be loaded parallelly. It also cache the loaded script to avoid duplicated loading. More lively description see use case below.

Properties

Decorated component will receive following properties:

Name	Type	Description
isScriptLoaded	Boolean	Represent scripts loading process is over or not, maybe part of scripts load failed.
isScriptLoadSucceed	Boolean	Represent all scripts load successfully or not.
onScriptLoaded	Function	Triggered when all scripts load successfully.

How to use

You can use it to decorate your component.

import React, { Component } from 'react'
import scriptLoader from 'react-async-script-loader'

class Editor extends Component {
  ...

  componentWillReceiveProps ({ isScriptLoaded, isScriptLoadSucceed }) {
    if (isScriptLoaded && !this.props.isScriptLoaded) { // load finished
      if (isScriptLoadSucceed) {
        this.initEditor()
      }
      else this.props.onError()
    }
  }

  componentDidMount () {
    const { isScriptLoaded, isScriptLoadSucceed } = this.props
    if (isScriptLoaded && isScriptLoadSucceed) {
      this.initEditor()
    }
  }

  ...
}

export default scriptLoader(
  [
    'https://cdnjs.cloudflare.com/ajax/libs/jquery/2.1.4/jquery.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/marked/0.3.5/marked.min.js'
  ],
  '/assets/bootstrap-markdown.js'
)(Editor)
*/
var React = require("react");
var PropTypes = require("prop-types");
var utils_1 = require("./utils");
var loadedScript = [];
var pendingScripts = {};
var failedScript = [];
function startLoadingScripts(scripts, onComplete) {
    if (onComplete === void 0) { onComplete = utils_1.noop; }
    // sequence load
    var loadNewScript = function (script) {
        var src = typeof script === 'object' ? script.src : script;
        if (loadedScript.indexOf(src) < 0) {
            return function (taskComplete) {
                var callbacks = pendingScripts[src] || [];
                callbacks.push(taskComplete);
                pendingScripts[src] = callbacks;
                if (callbacks.length === 1) {
                    return utils_1.newScript(script)(function (err) {
                        pendingScripts[src].forEach(function (cb) { return cb(err, src); });
                        delete pendingScripts[src];
                    });
                }
            };
        }
    };
    var tasks = scripts.map(function (src) {
        if (Array.isArray(src)) {
            return src.map(loadNewScript);
        }
        return loadNewScript(src);
    });
    utils_1.series.apply(void 0, tasks)(function (err, src) {
        if (err) {
            failedScript.push(src);
        }
        else {
            if (Array.isArray(src)) {
                src.forEach(addCache);
            }
            else
                addCache(src);
        }
    })(function (err) {
        removeFailedScript();
        onComplete(err);
    });
}
exports.startLoadingScripts = startLoadingScripts;
var addCache = function (entry) {
    if (loadedScript.indexOf(entry) < 0) {
        loadedScript.push(entry);
    }
};
var removeFailedScript = function () {
    if (failedScript.length > 0) {
        failedScript.forEach(function (script) {
            var node = document.querySelector("script[src='" + script + "']");
            if (node != null) {
                node.parentNode.removeChild(node);
            }
        });
        failedScript = [];
    }
};
var hoistStatics = require('hoist-non-react-statics');
function scriptLoader() {
    var scripts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        scripts[_i] = arguments[_i];
    }
    return function wrapScript(WrappedComponent) {
        var ScriptLoader = /** @class */ (function (_super) {
            __extends(ScriptLoader, _super);
            function ScriptLoader(props, context) {
                var _this = _super.call(this, props, context) || this;
                _this.state = {
                    isScriptLoaded: false,
                    isScriptLoadSucceed: false,
                };
                _this._isMounted = false;
                return _this;
            }
            ScriptLoader.prototype.componentDidMount = function () {
                var _this = this;
                this._isMounted = true;
                startLoadingScripts(scripts, function (err) {
                    if (_this._isMounted) {
                        _this.setState({
                            isScriptLoaded: true,
                            isScriptLoadSucceed: !err,
                        }, function () {
                            if (!err) {
                                _this.props.onScriptLoaded();
                            }
                        });
                    }
                });
            };
            ScriptLoader.prototype.componentWillUnmount = function () {
                this._isMounted = false;
            };
            ScriptLoader.prototype.getWrappedInstance = function () {
                return this.refs.wrappedInstance;
            };
            ScriptLoader.prototype.render = function () {
                var props = __assign({}, this.props, this.state, { ref: 'wrappedInstance' });
                return React.createElement(WrappedComponent, __assign({}, props));
            };
            ScriptLoader.propTypes = {
                onScriptLoaded: PropTypes.func,
            };
            ScriptLoader.defaultProps = {
                onScriptLoaded: utils_1.noop,
            };
            return ScriptLoader;
        }(React.Component));
        return hoistStatics(ScriptLoader, WrappedComponent);
    };
}
exports.scriptLoader = scriptLoader;
var scriptDidLoad = function (thisProps, nextProps) {
    return nextProps.isScriptLoaded && !thisProps.isScriptLoaded && nextProps.isScriptLoadSucceed;
};
exports.scriptDidLoad = scriptDidLoad;
//# sourceMappingURL=index.js.map